// import React, { useEffect } from 'react'
import React from 'react'
import {
  formatMessageNew
  // paginationInit
} from '@/utils/common'
// import { configQuery } from '@/services/welcome'
import './Welcome.less'
const Welcome = () => {
  // useEffect(() => {
  //   // 调用一个接口，判断是否登录失效
  //   searchDataFun()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])
  // const searchDataFun = () => {
  //   const params = {
  //     configKey: 'channel',
  //     configStatus: '',
  //     configType: 'channel_config',
  //     pageNo: paginationInit.currentPage,
  //     size: paginationInit.pageSize,
  //     total: paginationInit.total
  //   }
  //   configQuery(params).then(() => {})
  // }
  return (
    <div className="welcome">
      <div className="welcome-logo">
        <span className="nsg-glyph--swoosh" />
      </div>
      <h2 className="welcome-text m0">{formatMessageNew('languageObj.welcomeLocale.welcome')}</h2>
    </div>
  )
}

export default Welcome
